// extracted by mini-css-extract-plugin
export default {"tabs":"tabs-HFSP","item":"item-Q_a3"};